
import type {PropType} from 'vue'
import {defineComponent} from 'vue';
import {CategoryTab} from "./models/CategoryTab";

export default defineComponent({
    name: 'CategoryTabs',
    props: {
        tabs: {
            type: Array as PropType<Array<CategoryTab>>,
            required: true
        },
        activeTabId: {
            type: String,
            required: true
        },
        ariaLabel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showLeft: false,
            showRight: false
        }
    },
    computed: {
    },
    mounted() {
        this.updateArrows();
        this.$refs.scrollContainer.addEventListener('scroll', this.updateArrows);
        window.addEventListener('resize', this.updateArrows);
    },
    beforeUnmount() {
        this.$refs.scrollContainer.removeEventListener('scroll', this.updateArrows);
        window.removeEventListener('resize', this.updateArrows);
    },
    methods: {
        clickHandler(tabId: string) {
            this.$emit('tab-click', tabId);
        },
        updateArrows() {
            const container = this.$refs.scrollContainer as HTMLElement;
            if (container) {
                this.showLeft = container.scrollLeft > 0;
                this.showRight = container.scrollLeft + container.clientWidth + 1 < container.scrollWidth;// On ajoute 1 pour se prémunir du delta causé par les arrondis
            }
        },
        scrollLeft() {
            const container = this.$refs.scrollContainer as HTMLElement;
            if (container) {
                container.scrollBy({left: -150, behavior: 'smooth'});
            }
        },
        scrollRight() {
            const container = this.$refs.scrollContainer as HTMLElement;
            if (container) {
                container.scrollBy({left: 150, behavior: 'smooth'});
            }
        }
    }
});
